import { Button } from '@mui/material';
import { useState } from 'react';
import { License } from '../../api/api-generated';
import SoftwareSoldModulesManagementDialog from './SoftwareSoldModulesManagementDialog';

interface Props {
  license: License;
}

const SoftwareSoldModulesButton = ({ license }: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const openDialog = (event: React.MouseEvent) => {
    event.stopPropagation();
    setDialogOpen(true);
  };
  return (
    <>
      <Button onClick={openDialog} variant='outlined' color='primary'>
        Modules
      </Button>
      <SoftwareSoldModulesManagementDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        license={license}
      />
    </>
  );
};

export default SoftwareSoldModulesButton;
